<template>
  <div class="application-form">
    <h2 class="form-title">{{ t('applicationForm') }}</h2>
    <form @submit.prevent="submitForm" class="form-container">
      <div class="form-group">
        <label for="englishName" class="form-label">{{ t('englishName') }}</label>
        <input 
          type="text" 
          id="englishName" 
          v-model="formData.englishName" 
          class="form-input" 
          required
          :placeholder="t('inputEnglishName')"
        >
      </div>
      
      <div class="form-group">
        <label for="chineseName" class="form-label">{{ t('chineseName') }}</label>
        <input 
          type="text" 
          id="chineseName" 
          v-model="formData.chineseName" 
          class="form-input" 
          required
          :placeholder="t('inputChineseName')"
        >
      </div>
      
      <div class="form-group">
        <label for="email" class="form-label">{{ t('applicationEmail') }}</label>
        <input 
          type="email" 
          id="email" 
          v-model="formData.email" 
          class="form-input" 
          required
          :placeholder="t('inputEmail')"
        >
      </div>
      
      <div class="form-group">
        <label for="phone" class="form-label">{{ t('phoneNumber') }}</label>
        <input 
          type="tel" 
          id="phone" 
          v-model="formData.phone" 
          class="form-input" 
          required
          :placeholder="t('inputPhone')"
        >
      </div>
      
      <div class="form-group">
        <label for="address" class="form-label">{{ t('applicationAddress') }}</label>
        <textarea 
          id="address" 
          v-model="formData.address" 
          class="form-textarea" 
          rows="3"
          :placeholder="t('inputAddress')"
        ></textarea>
      </div>
      
      <div class="form-group">
        <label for="remarks" class="form-label">{{ t('remarks') }}</label>
        <textarea 
          id="remarks" 
          v-model="formData.remarks" 
          class="form-textarea" 
          rows="4"
          :placeholder="t('inputRemarks')"
        ></textarea>
      </div>
      
      <div class="form-actions">
        <button type="submit" class="submit-button" :disabled="submitting">
          {{ submitting ? t('submitting') : t('submit') }}
        </button>
        <button type="button" class="cancel-button" @click="goBack">
          {{ t('goBack') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  setup() {
    const router = useRouter();
    const { t } = useI18n();
    const submitting = ref(false);
    
    const formData = reactive({
      englishName: '',
      chineseName: '',
      email: '',
      phone: '',
      address: '',
      remarks: ''
    });
    
    const submitForm = async () => {
      submitting.value = true;
      
      try {
        // 这里可以添加表单验证逻辑
        console.log('表单数据:', formData);
        
        // 模拟API请求
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // 提交成功后的处理
        alert(t('submitSuccess'));
        router.push('/'); // 返回首页
      } catch (error) {
        console.error('提交失败:', error);
        alert(t('submitFailed'));
      } finally {
        submitting.value = false;
      }
    };
    
    const goBack = () => {
      router.back();
    };
    
    return {
      t,
      formData,
      submitting,
      submitForm,
      goBack
    };
  }
});
</script>

<style scoped>
.application-form {
  max-width: 800px;
  margin: 120px auto 40px;
  padding: 0 20px;
}

.form-title {
  text-align: center;
  font-size: 28px;
  margin-bottom: 30px;
  color: #333;
}

.form-container {
  background-color: #fff;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.form-group {
  margin-bottom: 25px;
}

.form-label {
  display: block;
  font-size: 16px;
  margin-bottom: 8px;
  color: #555;
  font-weight: 500;
}

.form-input {
  width: 100%;
  padding: 12px 15px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 6px;
  transition: border-color 0.3s;
}

.form-input:focus {
  outline: none;
  border-color: #12aa4a;
  box-shadow: 0 0 0 2px rgba(18, 170, 74, 0.1);
}

.form-textarea {
  width: 100%;
  padding: 12px 15px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 6px;
  resize: vertical;
  transition: border-color 0.3s;
}

.form-textarea:focus {
  outline: none;
  border-color: #12aa4a;
  box-shadow: 0 0 0 2px rgba(18, 170, 74, 0.1);
}

.form-actions {
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 40px;
}

.submit-button {
  padding: 12px 30px;
  font-size: 16px;
  background-color: #12aa4a;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-button:hover:not(:disabled) {
  background-color: #0e8e3e;
}

.submit-button:disabled {
  background-color: #999;
  cursor: not-allowed;
}

.cancel-button {
  padding: 12px 30px;
  font-size: 16px;
  background-color: #f0f0f0;
  color: #333;
  border: 1px solid #ddd;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.cancel-button:hover {
  background-color: #e0e0e0;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .application-form {
    margin: 80px auto 20px;
  }
  
  .form-container {
    padding: 20px;
  }
  
  .form-actions {
    flex-direction: column;
  }
  
  .submit-button, .cancel-button {
    width: 100%;
  }
}
</style>